import { UserRole } from '@lmc/ts-common'
import { EmptyState, NotFoundIcon } from '@lmc/ui-kit'
import { TabBarWrapper } from 'components/generic/TabBar/TabBarWrapper'
import { get } from 'lodash'
import { Component } from 'react'
import { isBrowser, isTablet } from 'react-device-detect'
import { connect } from 'react-redux'
import { Link, Navigate, Outlet } from 'react-router-dom'
import Selectors from 'selectors'
import { isGroupUser } from 'utils'
import { withRouter } from '../../../withRouter'

const isDesktop = isBrowser || isTablet

export class OrganisationScreen extends Component {
  // Use view UserInvitation as a proxy: only admins and CARE_MANAGEMENT have it
  hasTeamPermissions = () =>
    this.props.hasAccess(
      [],
      [
        {
          i: 'view',
          this: 'UserInvitation'
        }
      ]
    )

  hasDevicePermissions = () => {
    return this.props.hasAccess([], [{ i: 'view', this: 'MobileDevice' }])
  }

  hasDocumentPermissions = () => {
    return this.props.hasAccess([], [{ i: 'delete', this: 'Document' }])
  }

  hasShiftPermissions = () => {
    return this.props.hasAccess([], [{ i: 'update', this: 'Shift' }])
  }

  hasAbsencePermissions = () => {
    return this.props.role !== UserRole.it
  }

  renderTabs = () => {
    const { location, role, features, hasRota } = this.props

    const hasDevicePermission = this.hasDevicePermissions()
    const hasDocumentPermission = this.hasDocumentPermissions()
    const hasShiftPermission = this.hasShiftPermissions()
    const hasAbsencePermission = this.hasAbsencePermissions()

    const deviceAccessControlGranted =
      features?.features?.deviceAccessControl?.granted

    const tabs = [
      { url: 'list', label: 'Team Members List', octicon: 'organization' },
      ...(hasShiftPermission
        ? [
            {
              url: 'shift-passwords',
              label: 'Shift Passwords',
              octicon: 'key'
            }
          ]
        : []),
      ...(hasDocumentPermission
        ? [
            {
              url: 'documents',
              label: 'Documents',
              octicon: 'file'
            }
          ]
        : []),
      ...(deviceAccessControlGranted && hasDevicePermission
        ? [
            {
              url: 'devices',
              label: 'Devices'
            }
          ]
        : []),
      ...(hasRota && hasAbsencePermission
        ? [
            {
              url: 'all-absences',
              label: 'All Absences'
            }
          ]
        : [])
    ]

    if (!isDesktop || isGroupUser(role)) {
      return null
    }

    return (
      <div style={styles.navbar} data-testid="organisation-navigation">
        <TabBarWrapper
          items={tabs}
          location={location}
          resourceUrl="organisation"
          testId="organisation-tab-bar"
        />
      </div>
    )
  }

  render() {
    const { router, permissionsLoading } = this.props

    if (permissionsLoading) return null

    const hasTeamPermission = this.hasTeamPermissions()

    if (!hasTeamPermission) {
      return (
        <EmptyState
          title="We cant find what you're looking for... Error 404"
          description="Don't worry, try refreshing the page and if the problem persists contact support."
          icon={<NotFoundIcon />}
          testId="organisation-404-error"
        >
          <Link to="/" data-testid="organisation-go-back-home">
            Go back home
          </Link>
        </EmptyState>
      )
    }

    return (
      <div data-testid="organisation-screen">
        {this.renderTabs()}
        {router.location.pathname === '/organisation' ? (
          <Navigate to="team" />
        ) : (
          <Outlet />
        )}
      </div>
    )
  }
}

const styles = {
  navbar: {
    zIndex: 2
  }
}

const mapStateToProps = (state) => ({
  role: get(state, 'global.user.role'),
  isDeviceAccessControl: get(state, 'global.home.deviceAccessControl'),
  features: state.global.home,
  permissionsLoading: get(state, 'global.permissionsLoading', true),
  hasAccess: (roles, abilities) =>
    Selectors.checkRoleAccess(state, { roles, abilities })
})

export default connect(mapStateToProps)(withRouter(OrganisationScreen))
